module.exports = __webpack_public_path__ + "static/img/eyebrows_03.babd74c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/eyebrows/thumbnail/eyebrows_03.png
// module id = WrYK
// module chunks = 0